import {
  isRequired,
  isNumber,
  isDate,
  type Validation,
} from './utils';

const validations: Validation[] = [
  ({ paymentDate }) => isDate(paymentDate) || { paymentDate: 'payment date should be a valid date.' },
  ({ transactionId }) => isRequired(transactionId) || { transactionId: 'Transaction id is required.' },
  ({ description }) => isRequired(description) || { description: 'Description is required.' },
  ({ amount }) => isNumber(amount) || { amount: 'amount should be a valid number.' },
];

const KEYS = [
  'paymentDate',
  'transactionId',
  'description',
  'amount',
];

export {
  validations,
  KEYS,
};
